import { useMediaQuery } from '@mui/material';

function useMobileScreen() {
  const telaMobile = useMediaQuery('(max-width:768px)');

  return telaMobile;
}

export default useMobileScreen;